import React, { useEffect } from 'react';
import classNames from 'classnames';
import styles from '../assets/student-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from './react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import dateTimeFilter from 'src/components/react-table/filters/datetime-filter';
import { QueryParams } from 'src/types/grid';
import { IStudent } from 'src/types/student';
import StudentActionsColumn from './StudentActionsColumn';
import { CellProps } from 'react-table';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import { getValFromEnum } from '../../../../../../../components/redux-form/utils/dropdown-values';
import { IProvider } from 'src/types/provider';
import user from 'src/services/user-auth';
import dropDownFilter from 'src/components/react-table/filters/dropdown-filter';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';
import moment from 'moment';

interface Props {
    data: Paginated<IStudent>;
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
}
const studentStatuses: any = user.getStudentAvailableStatus();
const selectValuesStatus: SelectObject[] = getValFromEnum(studentStatuses);
const arrStatuses: string[] = Object.keys(studentStatuses);

const columns: Column<IStudent>[] = [
    {
        Header: 'ID',
        accessor: 'id',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IStudent>) => (
            <Link to={Router.generate(routes.STUDENT_DETAIL, { id: original.id, tab: 'student-info' })}>
                {original.id}
            </Link>
        ),
        Filter: textFilter<IStudent>(),
    },
    {
        Header: 'First Name',
        accessor: 'firstName',
        Filter: textFilter<IStudent>(),
    },
    {
        Header: 'Last Name',
        accessor: 'lastName',
        Filter: textFilter<IStudent>(),
    },
    {
        Header: 'Address',
        accessor: 'address',
        Filter: textFilter<IStudent>(),
    },
    {
        Header: 'Parent',
        accessor: 'parentFirstName',
        Filter: textFilter<IStudent>(),
    },
    {
        Header: 'Parent Last Name',
        accessor: 'parentLastName',
        Filter: textFilter<IStudent>(),
    },
    {
        Header: 'Parent Email',
        accessor: 'parentPrimaryEmail',
        Filter: textFilter<IStudent>(),
    },
    {
        Header: 'P.Phone',
        accessor: 'parentPhone',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IStudent>) => {
            return (
                <a rel="noopener noreferrer" target="_blank" href={`tel:${original.parentPhone}`}>
                    {original.parentPhone}
                </a>
            );
        },
        Filter: textFilter<IStudent>(),
    },
    {
        Header: 'Attorney',
        accessor: 'attorneyFullName',
        disableSortBy: true,
        Filter: textFilter<IStudent>(),
    },
    {
        Header: 'Attorney Email',
        accessor: 'attorneyPrimaryEmail',

        Filter: textFilter<IStudent>(),
    },
    {
        Header: 'Att.Phone',

        accessor: 'attorneyPhoneNumber',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IStudent>) => {
            return (
                <a rel="noopener noreferrer" target="_blank" href={`tel:${original.attorneyPhoneNumber}`}>
                    {original.attorneyPhoneNumber}
                </a>
            );
        },
        Filter: textFilter<IStudent>(),
    },
    {
        Header: 'Created',
        accessor: 'createdAt',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IStudent>) => changeToZeroMoment(original.createdAt, 'MMM D, YYYY'),
        Filter: dateTimeFilter<IStudent>(),
    },

    {
        Header: 'Status',
        accessor: 'status',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IProvider>) => arrStatuses.filter((itF) => original.status === studentStatuses[itF]),

        Filter: dropDownFilter<IStudent>(selectValuesStatus, styles.minWidth),
    },
    {
        Header: 'Actions',
        accessor: 'updated',
        Cell: StudentActionsColumn,
        disableSortBy: true,
        disableFilters: true,
        width: '10%',
    },
];

const StudentsGrid: React.FunctionComponent<Props> = ({ data, getData, getDataCsv }: Props) => {
    const filtersInit: any[] = [];

    const match: any = useRouteMatch();
    const locationObject: any = useLocation();
    const query = new URLSearchParams(locationObject.search);

    if (query.get('seanceActive')) {
        match.params.dateTo = moment().format('YYYY-MM-DD');
        match.params.dateFrom = moment().subtract(query.get('seanceActive'), 'days').format('YYYY-MM-DD');
    }

    useEffect(() => {
        if ((Object.values(match.params).length && match.params.dateFrom) || match.params.dateFrom) {
            Object.keys(match.params).forEach((k) => {
                filtersInit.push({ id: k, value: +match.params[k] });
            });
        }
        if ((Object.values(match.params).length && match.params.dateTo) || match.params.dateTo) {
            Object.keys(match.params).forEach((k) => {
                filtersInit.push({ id: k, value: +match.params[k] });
            });
        }
    }, []); // eslint-disable-line

    return (
        <div className={classNames(styles.grid)}>
            <Grid<IStudent>
                filterGlobal={true}
                filtersInit={filtersInit}
                columns={columns}
                data={data}
                getData={getData}
                getDataCsv={getDataCsv}
            />
        </div>
    );
};

export default StudentsGrid;
